import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PublicationCreateUpdateDialogComponent } from "./publication-create-update-dialog.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { EditorModule } from "@tinymce/tinymce-angular";
import { FlagModule } from "../../flag/flag.module";

@NgModule({
  declarations: [PublicationCreateUpdateDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatMenuModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTooltipModule,
    EditorModule,
    FlagModule,
  ],
  exports: [PublicationCreateUpdateDialogComponent],
})
export class PublicationCreateUpdateDialogModule {}
